import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BeanStatus } from '../../../../bean/BeanStatus';

@Injectable()

export class StatusService {

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders(){

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public listarStatus():Promise<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarStatus}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  public listarStatusAtivos():Promise<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarStatusAtivos}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  public getStatus(id:string):Promise<any>{

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.getStatus}${id}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  addStatus(formModel: BeanStatus):Promise<any>{
    return this.gravarStatus(formModel).toPromise().then((resposta:any) => resposta);
  }

  public gravarStatus(formModel: BeanStatus):Observable<any>{

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.post(`${environment.urlBackend}${environment.criarStatus}`,json, {headers});
  }

  updateStatus(formModel: BeanStatus):Promise<any>{
    return this.atualizarStatus(formModel).toPromise().then((resposta:any) => resposta);
  }

  public atualizarStatus(formModel: BeanStatus):Observable<any> {

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.put(`${environment.urlBackend}${environment.updateStatus}${formModel.statIdCdStatus}`, json, {headers});
  }
}
